// extracted by mini-css-extract-plugin
module.exports = {"certificates":"style_certificates__9Q1wR","certificates__wrapper":"style_certificates__wrapper__g3Vte","certificates__grid":"style_certificates__grid__Mj6m2"};